import ActivityIndicator from 'antd-mobile/lib/activity-indicator';
export default ActivityIndicator;



// WEBPACK FOOTER //
// ./components/activity-indicator/index.tsx